<section class="container job-pt-3">
  <a class="btn btn-green ml-3" [routerLink]="['/agent','ads','save']">ثبت آگهی</a>
  <div class="btn btn-blue" (click)="load()" title="دریافت مجدد اطلاعات">دریافت آمار آگهی‌ها</div>

  <ul class="nav nav-tabs mt-2">
    <li class="nav-item">
      <span class="nav-link " [class.active]="!archived" (click)="archived=false">آگهی های فعال</span>
    </li>
    <li class="nav-item">
      <span class="nav-link" [class.active]="archived" (click)="archived=true">آگهی های آرشیو شده</span>
    </li>
  </ul>

  <section class="tab-content" *ngIf="jobs?.length">
    <div class="col-12">
      <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
    </div>

    <section class=" ">
      <div class="row flex-row kp-card" *ngFor="let job of jobs;let i=index" [ngSwitch]="job.Status">
        <div class="col-12">
          <header class="fs-sm f-gray">
            {{job.StartTime|pdate}}
            <span class="float-left" *ngIf="job.Code">کد آگهی: KP{{job.Code}}</span>
          </header>
          <a [routerLink]="['/job',job.Id]" target="_blank">
            <img class="d-inline-block" *ngIf="job.Image" 
              [src]="job.Image?.startsWith('http') ? job.Image : imageUrl+job.Image"
              (error)="$event.target.style.display='none'" style="max-height:80px;max-width:80px" />
            <h3 class="d-inline-block">{{job.Title}} <span class="ml-2 fs-sm" *ngIf="job.Company"><strong>کارفرما:
                </strong>
                {{job.Company}}</span></h3>
          </a>
          {{[job.State,job.City,job.District]|join:' - '}}

          <ul class="">
            <li *ngFor="let skill of job.RequiredSkills">{{skill}}</li>
            <li *ngFor="let type of job.JobTypes">{{type}}</li>
            <li *ngIf="job.IsRemote">دورکاری</li>
            <li *ngFor="let education of job.Educations">{{education}}</li>
          </ul>
        </div>
        <div class="alert-tag" *ngSwitchCase="JobStatus.NotPaid">
          در انتظار {{job.PackageKey?'پرداخت':'انتخاب بودجه'}}<br />
        </div>
        <div class="alert-tag" *ngSwitchCase="JobStatus.Pending">
          در انتظار تایید
        </div>
        <div class="alert-tag warning" *ngSwitchCase="JobStatus.Rejected">
          مرجوع شده
        </div>
        <ng-container *ngSwitchCase="JobStatus.Started">
          <div class="alert-tag succeed" *ngIf="!job.IsExpired"> در حال پخش </div>
          <div class="alert-tag" *ngIf="job.IsExpired">منقضی شده</div>
        </ng-container>
        <div class="alert-tag warning" *ngSwitchCase="JobStatus.Paused">
          موقتا متوقف شده
        </div>
        <div class="alert-tag warning" *ngSwitchCase="JobStatus.Archived">
          آرشیو شده
        </div>
        <ng-container *ngSwitchCase="JobStatus.Finished"></ng-container>
        <div *ngIf="job.Status == JobStatus.Rejected && job.RejectionReason" class="alert alert-danger">دلیل مرجوع شدن:
          <pre>{{job.RejectionReason}}</pre>
        </div>
        <div class="job-statistics row">
          <ng-container>
            <div class="col-6 col-md">{{(!clicks[job.Id]?0:clicks[job.Id][0]||0)|number}} بازدید</div>
            <div class="col-6 col-md">{{(!clicks[job.Id]?0:clicks[job.Id][1]||0)|number}} بار دریافت اطلاعات تماس
            </div>
            <div class="col-6 col-md" [routerLink]="['/employer','applies',job.Id]">{{(applies[job.Id]||0)|number}} داوطلب</div>
          </ng-container>
          <div class="col-6 col-md" *ngIf="job.Budget>0">{{job.Budget|number}} تومان</div>
          <div class="col-6 col-md f-green" *ngIf="job.Budget>0">بودجه
            باقیمانده:&nbsp;<span>{{job.RemainingBudget|number}}</span>&nbsp;تومان</div>
        </div>
        <div class="btn-group flex">
          <ng-container *ngSwitchCase="JobStatus.NotPaid">
            <button class="btn btn-blue" type="button" [routerLink]="['/agent','edit',job.Id]">ویرایش</button>
            <button class="btn btn-red" type="button" (click)="archive(job,i)">آرشیو</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Pending">
            <button class="btn btn-blue" type="button" [routerLink]="['/agent','ads','save',job.Id]">ویرایش</button>
            <button class="btn btn-red" type="button" (click)="archive(job,i)">آرشیو</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Rejected">
            <button class="btn btn-blue" type="button" [routerLink]="['/agent','ads','save',job.Id]">ویرایش</button>
            <button class="btn btn-red" type="button" (click)="archive(job,i)">آرشیو</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Started">
            <button class="btn btn-blue" type="button" [routerLink]="['/agent','ads','save',job.Id]">ویرایش</button>
            <button class="btn btn-red" type="button" (click)="pause(job,i)">توقف موقت</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Paused">
            <button class="btn btn-blue" type="button" [routerLink]="['/agent','ads','save',job.Id]">ویرایش</button>
            <button class="btn btn-green" type="button" (click)="start(job,i)">شروع مجدد</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Archived">
            <button class="btn btn-yellow" type="button" (click)="unArchive(job,i)">فعال سازی</button>
          </ng-container>
          <ng-container *ngSwitchCase="JobStatus.Finished"></ng-container>
        </div>
      </div>
    </section>
  </section>

</section>